import Panel from 'shared/components/panels/Panel';
import PanelHeader from 'shared/components/panels/PanelHeader';
import PanelStack from 'shared/components/panels/PanelStack';
import PanelSeparator from 'shared/components/panels/PanelSeparator';
import PanelSubheader from 'shared/components/panels/PanelSubheader';
import PanelEmptyState from 'shared/components/panels/PanelEmptyState';
import PanelSpinner from 'shared/components/panels/PanelSpinner';

Panel.Header = PanelHeader;
Panel.Stack = PanelStack;
Panel.Separator = PanelSeparator;
Panel.Subheader = PanelSubheader;
Panel.EmptyState = PanelEmptyState;
Panel.Spinner = PanelSpinner;

export {
  Panel
};
